import { getGiftProjectsAffiliateLinks } from "../api";
import { affiliateLinkDetailsKeys } from "./keys";
import { useAffiliateLinkDetailQuery } from "./use-affiliate-link-detail-query";

export const useAffiliateLinkGiftProjectsQuery = (id, enabled = true) =>
  useAffiliateLinkDetailQuery({
    queryKey: affiliateLinkDetailsKeys.giftProjects(id),
    fetcher: getGiftProjectsAffiliateLinks,
    id,
    dataKey: "affiliateLinksWithGiftProjectProjects",
    enabled,
  });
